<div class="uyTerms__entry-content">
  <div class="title">
    <p>
      CONDICIONES GENERALES Y COMPLEMENTARIAS DEL CONTRATO DE SERVICIOS TUR&Iacute;STICOS DE Rappi Travel&nbsp;
    </p>
  </div>

  <div class="uyTerms__box-content">
    <h4>CONDICIONES GENERALES</h4>
    <div><span>1.&nbsp;</span><strong><span>Brisanier S.A.</span></strong><span>&nbsp;(en
        adelante</span><span>&nbsp;&quot;Rappi
        Travel&quot;</span><span>)</span><span>&nbsp;es una agencia de
        viajes en l&iacute;nea,</span><span>&nbsp;con domicilio en la ciudad de Montevideo,
        Rep&uacute;blica Oriental del Uruguay.</span></div>
    <div><span>2. Rappi Travel
        permite a una gran cantidad de prestadores de servicios tur&iacute;sticos (en adelante &quot;Prestador&quot; o
        &quot;Prestadores&quot;) ofrecer y comercializar sus productos y/o servicios a los Usuarios/Consumidores de la
        plataforma Rappi, quienes a su vez pueden realizar averiguaciones sobre a</span><span>lojamientos, cruceros,
        vuelos,
        actividades</span><span>, alquiler
        de autos y dem&aacute;s servicios tur&iacute;sticos (en adelante &quot;Servicios Tur&iacute;sticos), as&iacute;
        como
        comparar y reservar dichos Servicios Tur&iacute;sticos en tiempo real y adquirirlos por separado o
        combinados,&nbsp;</span><span>armando</span><span>&nbsp;y
        gestionando su viaje, de conformidad con sus intereses por medio de la plataforma Rappi.</span></div>
    <div><span>3. En el marco de
        sus actividades Rappi Travel opera &uacute;nicamente como intermediario entre los Usuarios/Consumidores y los
        Prestadores, entendi&eacute;ndose que Rappi Travel no es el Prestador de los Servicios Tur&iacute;sticos. Por lo
        anterior, el Usuario/Consumidor que contrata los Servicios Tur&iacute;sticos a trav&eacute;s de Rappi Travel, lo
        hace directamente con el Prestador.</span></div>
    <div><span>4. Se aclara que
        los presentes t&eacute;rminos y condiciones no&nbsp;</span><span>remplazan</span><span>, modifican o suplen los
        t&eacute;rminos y condiciones que cada Prestador establezca para
        el disfrute de los Servicios Tur&iacute;sticos que presta; por esta raz&oacute;n, resulta indispensable que
        antes de
        adquirir cualquier Servicio Tur&iacute;stico por intermedio de Rappi Travel, el Usuario/Consumidor consulte
        directamente las condiciones, especificaciones y particularidades que cada Prestador haya establecido para el
        Servicio Tur&iacute;stico que desea adquirir. Lo anterior, en la medida en que Rappi Travel no establece, ni
        participa en la formulaci&oacute;n de los t&eacute;rminos y condiciones que cada Prestador maneja con
        relaci&oacute;n a sus productos y servicios.</span></div>
    <div><span>5. De igual manera,
        al hacer uso del bot&oacute;n &quot;</span><span>RappiTravel</span><span>&quot; dentro de la plataforma Rappi,
        el
        Usuario/Consumidor acepta y garantiza que: (i) es
        mayor de edad, (ii) posee plena capacidad para la celebraci&oacute;n de contratos, (iii) est&aacute; adquiriendo
        los
        Servicios Tur&iacute;sticos para su uso personal o para quien le haya autorizado para actuar, (iv) toda la
        informaci&oacute;n proporcionada para la adquisici&oacute;n de los Servicios Tur&iacute;sticos por medio de
        Rappi
        Travel es real, precisa, actual y completa, (v) acepta haber le&iacute;do, entendido y estar de acuerdo con los
        presentes t&eacute;rminos y condiciones, (vi) en caso de adquirir Servicios Tur&iacute;sticos con destino/escala
        en
        Cuba, no es ciudadano ni residente Norteamericano, ni se encuentra sujeto a la jurisdicci&oacute;n de Estados
        Unidos.</span></div>
    <div><span>6. Para los efectos
        de los presentes t&eacute;rminos y condiciones, por Usuario/Consumidor se entender&aacute; aquella persona
        natural o
        jur&iacute;dica que adquiere Servicios Tur&iacute;sticos por medio del bot&oacute;n &quot;Rappi Travel&quot;
        dentro
        de la plataforma Rappi. Por Pasajero se entender&aacute; aquella persona natural o jur&iacute;dica que disfruta
        de
        los Servicios Tur&iacute;sticos adquiridos, entendi&eacute;ndose que el Pasajero no necesariamente es el
        Usuario/Consumidor. Se aclara que tanto los Usuarios/Consumidores como los Pasajeros deben dar cumplimiento a
        los
        presentes t&eacute;rminos y condiciones.</span></div>
    <h4>I. RESPONSABILIDAD</h4>
    <div><span>1. Rappi Travel no
        se responsabiliza por ninguna clase de situaci&oacute;n de fuerza mayor (accidentes, huelgas, asonadas,
        terremotos,
        fen&oacute;menos clim&aacute;ticos o naturales, condiciones de seguridad, factores pol&iacute;ticos,
        negaci&oacute;n
        de permisos de ingreso, asuntos de salubridad y cualquier otro), caso fortuito, hecho exclusivo de la
        v&iacute;ctima, o de un tercero que se presenten antes o durante la prestaci&oacute;n de los Servicios
        Tur&iacute;sticos que demoren, interrumpan o impidan su pleno disfrute, ni tampoco por los riesgos que para la
        salud
        e integridad representen los destinos tur&iacute;sticos elegidos por los Usuarios/Consumidores, pues corresponde
        a
        su responsabilidad informarse y tomar medidas al respecto. Para este efecto, se tendr&aacute;n en cuenta las
        deducciones, penalidades, condiciones y gastos de administraci&oacute;n previamente establecidos por los
        Prestadores, cuando los Servicios Tur&iacute;sticos no sean utilizados.</span></div>
    <div><span>2. Rappi Travel no
        se responsabiliza personalmente ni de forma solidaria con el Prestador, por las sumas solicitadas por parte de
        los
        Usuarios/Consumidores, as&iacute; como tampoco por los intereses que se generen, en caso de que el Prestador no
        realice el reembolso oportunamente. Lo anterior debido a que Rappi Travel es un intermediario entre los
        Usuarios/Consumidores y los Prestadores.</span></div>
    <div><span>3. El solo uso de
        la plataforma Rappi implica la aceptaci&oacute;n de todas y cada una de las condiciones generales y particulares
        incluidas en estos t&eacute;rminos y condiciones. Su lectura le permitir&aacute; ejercer&nbsp;</span><span>en
        mejor</span><span>&nbsp;forma sus derechos como consumidor. Le
        sugerimos imprimirlas y conservarlas, junto con el resto de la documentaci&oacute;n de viaje.</span></div>
    <div><span>4. Las
        reservaciones y boletas para la participaci&oacute;n en cruceros, eventos deportivos y culturales, congresos,
        ferias, exposiciones y similares se sujetar&aacute;n a las condiciones que se&ntilde;alen las empresas
        organizadoras
        de tales eventos para cada plan. Dichas condiciones se informar&aacute;n al Usuario/Consumidor al momento de la
        compra. En las condiciones espec&iacute;ficas de cada plan se indicar&aacute; la cuant&iacute;a de los anticipos
        y
        el plazo para el pago de la suma por parte del Usuario/Consumidor. Por lo anterior, Rappi Travel recomienda al
        Usuario/Consumidor revisar los t&eacute;rminos y condiciones particulares aplicables al Servicio
        Tur&iacute;stico
        que desea contratar.</span></div>
    <div><span>5. Rappi Travel se
        reserva el derecho de hacer cambios en el itinerario, fechas de viaje, hoteles de similar o superior
        categor&iacute;a, transportes, ante circunstancias de fuerza mayor o caso fortuito.</span></div>
    <div><span>6. Rappi Travel se
        limita a informar al Usuario/Consumidor sobre la documentaci&oacute;n requerida para facilitar su ingreso a los
        destinos nacionales e internacionales. Por lo anterior, es obligaci&oacute;n del Usuario/Consumidor verificar en
        la
        programaci&oacute;n de su desplazamiento el cumplimiento de dichos requisitos. Rappi Travel en ning&uacute;n
        caso se
        responsabiliza si un pa&iacute;s niega al pasajero el ingreso, ni tampoco se hace cargo por los gastos
        personales
        que le acarree tal eventualidad.</span></div>
    <div><span>7. Rappi Travel no
        se responsabiliza en ninguna circunstancia por la p&eacute;rdida o demora de equipaje o elementos personales del
        Usuario/Consumidor. El Usuario/Consumidor ser&aacute; el &uacute;nico responsable por la custodia de su equipaje
        y
        objetos personales, entre los cuales se incluyen los documentos de viaje.</span></div>
    <h4>II. PROCESO DE RESERVA Y COMPRA</h4>
    <div><span>1. Cuando el
        Usuario/Consumidor env&iacute;a una solicitud de compra a trav&eacute;s del bot&oacute;n
        &quot;</span><span>RappiTravel</span><span>&quot; dentro de la plataforma Rappi (en
        adelante &quot;Solicitud de Compra&quot;), autoriza a Rappi Travel a gestionar su reserva y a cursar el/los
        respectivo/s cargo/s a su cuenta o tarjeta. El Usuario/Consumidor debe prestar atenci&oacute;n a las
        comunicaciones
        posteriores, donde se le informar&aacute; sobre los avances y estado de su Solicitud de Compra. La
        confirmaci&oacute;n de la compra depende del pago &iacute;ntegro del precio y/o tarifa de todos los Servicios
        Tur&iacute;sticos, y mientras no se confirme el pago total de la reserva, la Solicitud de Compra quedar&aacute;
        en
        suspenso y podr&iacute;a ser cancelada por el Prestador. La confirmaci&oacute;n definitiva de los Servicios
        Tur&iacute;sticos y precios se producir&aacute; con la emisi&oacute;n del ticket electr&oacute;nico y/o voucher
        del
        servicio. La emisi&oacute;n del ticket electr&oacute;nico y/o voucher del servicio d&aacute; fe de la
        aceptaci&oacute;n de las condiciones del Prestador y la celebraci&oacute;n del contrato suscrito entre el
        Prestador
        y el Pasajero que aparece en dicho ticket electr&oacute;nico y/o voucher del servicio.</span></div>
    <div><span>2. Si la Solicitud
        de Compra quedara sujeta a confirmaci&oacute;n, los valores pagados antes de la confirmaci&oacute;n ser&aacute;n
        recibidos bajo concepto de reserva. Si finalmente la Solicitud de Compra fuera rechazada por cualquier motivo
        (por
        ejemplo, por saldo insuficiente en la tarjeta de cr&eacute;dito, por falta de disponibilidad, por
        variaci&oacute;n
        en la tarifa, entre otros), Rappi Travel proceder&aacute; a informarle al Usuario/Consumidor las opciones
        disponibles en caso de que desee insistir en la compra o reserva o, a su requerimiento, le devolver&aacute; los
        importes abonados.</span></div>
    <h4>III. MEDIO DE PAGO Y TARIFAS</h4>
    <div><span>1. Al realizar una
        reserva de uno o m&aacute;s Servicios Tur&iacute;sticos a trav&eacute;s del bot&oacute;n
        &quot;</span><span>RappiTravel</span><span>&quot; dentro de la plataforma Rappi, el
        Usuario/Consumidor debe&nbsp;</span><span>abonar i</span><span>)
        el precio o tarifa fijada por el Prestador, ii) los impuestos aplicables al Servicio Tur&iacute;stico; iii) el
        cargo
        de servicio &quot;service fee&quot; de Rappi Travel, en caso de que aplique; y iv) la Tarifa Administrativa
        (conforme se define dicho t&eacute;rmino m&aacute;s adelante).</span></div>
    <div><span>2. Los medios y
        formas de pago disponibles para cada Servicio Tur&iacute;stico son informados al Usuario/Consumidor al momento
        de
        solicitar la reserva a trav&eacute;s del bot&oacute;n &quot;</span><span>RappiTravel</span><span>&quot; dentro
        de la
        plataforma
        Rappi.</span></div>
    <div><span>3. Para pagos con
        tarjetas de cr&eacute;dito: a) El cargo de servicio &quot;service fee&quot; de Rappi Travel, en caso de que
        aplique,
        podr&iacute;a aplicarse &iacute;ntegro en la primera cuota a pesar de que el Usuario/Consumidor haya elegido la
        opci&oacute;n de pago en cuotas para el resto del precio o tarifa. b) Los intereses y/o impuestos que pudieran
        generar los pagos en cuotas, se suman al precio o tarifa propuesto para el Servicio Tur&iacute;stico, y dicho
        total
        se divide por la cantidad de cuotas seleccionada para el pago. c) En caso de cancelaciones posteriores a la
        compra,
        siempre que las condiciones particulares del Servicio Tur&iacute;stico lo permitan, Rappi Travel no
        reintegrar&aacute; ni se har&aacute; responsable por los intereses que la transacci&oacute;n original haya
        generado.
        d) El precio por pagar puede depender del tipo de cambio, por lo que se recomienda al Usuario/Consumidor tener
        esto
        en consideraci&oacute;n para viajes internacionales.</span></div>
    <div><span>4. Cuando el
        Usuario/Consumidor adquiere una tarifa promocional, salvo indicaci&oacute;n expresa en contrario, en este tipo
        de
        tarifas no se aceptan cambios, cancelaciones o reembolsos del importe de la reserva. El Servicio
        Tur&iacute;stico
        comprado con tarifa promocional debe ser usado en las condiciones en que fue comprado por el Usuario/Consumidor.
        Solo aplicar&aacute;n excepciones en los casos en que el Prestador&nbsp;</span><span>acepte</span><span>&nbsp;de
        manera expresa en sus t&eacute;rminos
        y condiciones, el pago de alguna penalidad, por el cambio de las condiciones del Servicio Tur&iacute;stico
        adquirido
        con una tarifa promocional. El Usuario/Consumidor ser&aacute; el responsable de validar los t&eacute;rminos y
        condiciones del Prestador correspondiente.</span></div>
    <h4>IV. REVERSIONES DE PAGO</h4>
    <div><span>El Art&iacute;culo 16
        de la Ley de Relaciones de Consumo - Defensa del Consumidor&nbsp;</span><span>le otorga al
        Usuario/Consumidor la facultad de solicitar la devoluci&oacute;n de su pago, cuando la adquisici&oacute;n de
        productos tur&iacute;sticos se realice a trav&eacute;s del Sitio web. Lo anterior, siempre que el pago se haya
        realizado con una tarjeta de cr&eacute;dito, d&eacute;bito o cualquier otro instrumento de pago
        electr&oacute;nico.
        Se aclara que, si la compra corresponde a un ticket a&eacute;reo, el Usuario/Consumidor no podr&aacute; acogerse
        a
        esta figura por expresa disposici&oacute;n de la regulaci&oacute;n mencionada. En estos casos, el
        Usuario/Consumidor
        podr&aacute; solicitar reversi&oacute;n de pagos por cualquiera de las siguientes causales.</span></div>
    <div><span>Cuando fue objeto
        de fraude.</span></div>
    <div><span>Cuando el cargo
        generado sobre el medio de pago corresponde a una operaci&oacute;n no solicitada.</span></div>
    <div><span>Cuando el producto
        y/o servicio adquirido no fue recibido.</span></div>
    <div><span>Cuando el producto
        y/o servicio recibido no corresponde a lo solicitado (no cumple con las caracter&iacute;sticas informadas o
        atribuidas a &eacute;ste).</span></div>
    <div><span>Cuando el producto
        y/o servicio es defectuoso.</span></div>
    <div><span>El Usuario/Consumidor
        podr&aacute; solicitar la reversi&oacute;n parcial del pago de aquellos productos respecto de los cuales se
        presente
        alguno de los eventos mencionados anteriormente, expresando claramente cu&aacute;l es el valor por el cual se
        solicita la reversi&oacute;n, el cual deber&aacute; corresponder al valor del producto o productos respecto de
        los
        cuales se presenta la causal.</span></div>
    <div><span>Para que proceda la
        devoluci&oacute;n del pago, dentro los cinco (5. d&iacute;as h&aacute;biles siguientes a la fecha en que el
        Usuario/Consumidor tuvo noticia de la operaci&oacute;n fraudulenta o no solicitada, o que recibi&oacute; la
        confirmaci&oacute;n de una compra no solicitada, deber&aacute; presentar una queja ingresando todos los datos a
        trav&eacute;s del bot&oacute;n denominado &quot;Soporte Travel&quot; y notificar del reclamo al emisor del
        instrumento de pago electr&oacute;nico utilizado para realizar la compra, el cual, en conjunto con los
        dem&aacute;s
        participantes del proceso de pago,&nbsp;</span><span>proceder&aacute;</span><span>&nbsp;a devolver la
        transacci&oacute;n al Usuario/Consumidor. Se aclara que la
        devoluci&oacute;n se ver&aacute; reflejada en la cuenta del Usuario/Consumidor en el t&eacute;rmino determinado
        por
        el emisor del instrumento de pago. Rappi Travel no tiene injerencia sobre dicho t&eacute;rmino.</span></div>
    <h4>V. DERECHO DE RETRACTO</h4>
    <div><span>Conforme a lo
        establecido en el art&iacute;culo 47 de la Ley 1480 de 2011 (Estatuto del Consumidor), para hacer efectivo el
        derecho de retracto, el Usuario/Consumidor deber&aacute; presentar la solicitud de retracto dentro de los cinco
        (5.
        d&iacute;as h&aacute;biles siguientes a la fecha en que realiz&oacute; la compra. Lo anterior, siempre y cuando
        no
        haya comenzado a prestarse el Servicio Tur&iacute;stico con anterioridad a dicho t&eacute;rmino. Para ejercer el
        derecho de retracto el Usuario/Consumidor deber&aacute; informar a Rappi Travel por escrito. Se aclara que el
        Usuario/Consumidor podr&aacute; realizar la solicitud de retracto a trav&eacute;s de los canales de
        comunicaci&oacute;n dispuestos al interior de la Plataforma Rappi, a trav&eacute;s del bot&oacute;n soporte al
        interior de &quot;Rappi Travel&quot;, enviando un correo electr&oacute;nico
        a&nbsp;</span><span>servicioalclienteuy&#64;rappitravel.com</span><span>&nbsp;, o llamando
        a&nbsp;</span><span>la l&iacute;nea telef&oacute;nica&nbsp;</span><span>+57 1 3285584 via Whats
        App</span><span>.
        Rappi Travel
        realizar&aacute; el seguimiento de la solicitud ante el Prestador y en caso de haber sido abonado, ser&aacute;
        el
        Prestador, quien directamente deber&aacute; proceder con la devoluci&oacute;n del dinero en la forma como lo
        tenga
        previsto en sus t&eacute;rminos y condiciones y/o pol&iacute;tica corporativa.</span></div>
    <h4>VI. CANCELACIONES</h4>
    <div><span>1. Si el
        Usuario/Consumidor solicita un cambio o cancelaci&oacute;n fuera de los plazos y procedimientos establecidos por
        el
        Prestador o por la ley, y la regulaci&oacute;n espec&iacute;fica de la tarifa seleccionada as&iacute; lo
        permitiera,
        Rappi Travel realizar&aacute; las gestiones de presentaci&oacute;n y seguimiento de la solicitud, pero la
        decisi&oacute;n final ser&aacute; del Prestador. Se aclara que la forma de proceder y las condiciones especiales
        que
        rigen para casos de cambios o cancelaciones en una reserva confirmada por el Usuario/Consumidor son determinadas
        por
        los Prestadores, quienes podr&aacute;n establecer multas o penalidades aplicables para los cambios solicitados.
        Igualmente, se aclara que cada Prestador define sus penalidades sin intervenci&oacute;n de Rappi Travel.</span>
    </div>
    <div><span>2. En el caso de
        devoluciones aprobadas por el Prestador, se podr&aacute; generar una reversi&oacute;n a la misma tarjeta con la
        cual
        se hizo la reserva, previa autorizaci&oacute;n del titular de la tarjeta. Si el pago fue realizado en efectivo
        y/o
        transferencia bancaria, Rappi Travel requerir&aacute; los datos bancarios para realizar el reembolso mediante
        transferencia bancaria. Los plazos de reembolso y/o de la reversi&oacute;n del
        cargo&nbsp;</span><span>depender&aacute;n</span><span>&nbsp;de cada Prestador.</span>
    </div>
    <div><span>3. El cargo de
        gesti&oacute;n y/o Tarifa Administrativa cobrada por Rappi Travel es de car&aacute;cter no reembolsable. En caso
        de
        cancelaci&oacute;n de reservas confirmadas por cualquier motivo, este cargo de gesti&oacute;n no ser&aacute;
        reintegrado al Usuario/Consumidor ya que corresponde a un servicio efectivamente prestado por Rappi Travel.
        As&iacute; mismo, en el caso supuesto que el Usuario/Consumidor solicite el cambio o la cancelaci&oacute;n de un
        Servicio Tur&iacute;stico, Rappi Travel podr&aacute; cobrar un cargo de gesti&oacute;n adicional.</span></div>
    <h4>VII. DATOS PERSONALES</h4>
    <div><span>1. Rappi Travel y
        Rappi INC, sus subsidiarias y/o filiales tratar&aacute;n los datos de los Usuarios/Consumidores de conformidad
        con
        la POL&Iacute;TICA DE TRATAMIENTO DE DATOS PERSONALES (</span><a
        href="https://legal.rappi.com/uruguay/aviso-de-privacidad/"><u><span>https://legal.rappi.com/uruguay/aviso-de-privacidad/</span></u></a><span>),&nbsp;</span><span>la
        Ley N&deg; 18.331 -Ley de
        Protecci&oacute;n de Datos Personale</span><span>s</span></div>
    <div><span>2. Al ingresar los
        datos personales en la plataforma Rappi, el Usuario/Consumidor declara que dichos datos son exactos, precisos y
        verdaderos, y asume el compromiso de actualizar dichos Datos Personales conforme resulte necesario. Rappi Travel
        no
        se responsabiliza por la certeza de los Datos Personales provistos por el Usuario/Consumidor, cuyos datos
        deber&aacute;n coincidir en forma exacta con la documentaci&oacute;n de viaje.</span></div>
    <div><span>3. El
        Usuario/Consumidor debe ingresar los datos fiscales exactos en el campo denominado &quot;Datos de
        Facturaci&oacute;n&quot; en el bot&oacute;n &quot;Rappi Travel&quot;, en aras de que Rappi Travel pueda emitir
        la
        correspondiente factura. En virtud de lo anterior, es responsabilidad del Usuario/Consumidor asegurarse de que
        los
        datos ingresados sean exactos, precisos y verdaderos. Rappi Travel no ser&aacute; responsable por la
        emisi&oacute;n
        de la factura con informaci&oacute;n&nbsp;</span><span>errada</span><span>&nbsp;proporcionada por el
        Usuario/Consumidor. En caso de registrarse errores en los datos
        de la factura, el Usuario/Consumidor podr&aacute; solicitar a trav&eacute;s del &aacute;rea de soporte de Rappi
        Travel, la correcci&oacute;n de la factura dentro de los tres (3. d&iacute;as h&aacute;biles siguientes a la
        recepci&oacute;n de la misma.</span></div>
    <h4>VIII. NO PRESENTACI&Oacute;N</h4>
    <div><span>Si el
        Usuario/Consumidor o el Pasajero no se presentan a utilizar su reserva en la fecha y horarios indicados o llegan
        de
        forma tard&iacute;a, &eacute;stos no tendr&aacute;n derecho a exigir la devoluci&oacute;n total o parcial del
        importe abonado.</span></div>
    <h4>IX. PREVENCI&Oacute;N RESPECTO A EXPLOTACI&Oacute;N, ABUSO O TURISMO SEXUAL CON MENORES DE EDAD</h4>
    <div><span>En virtud de la Ley
        N&deg; 17.815 de Violenecia Sexual contra Ni&ntilde;os, Adolescentes e Incapaces; la Ley N&deg; 18.250 de
        Migraciones y la Ley N&ordm; 17.823 la cual regula el C&oacute;digo de la Ni&ntilde;ez y la Adolescencia,
        s</span><span>e establecen disposiciones para prevenir y contrarrestar la
        explotaci&oacute;n sexual comercial, la pornograf&iacute;a, el turismo sexual y dem&aacute;s formas de abuso con
        menores de edad. Bajo ese entendido, cualquier incumplimiento a dichas disposiciones podr&iacute;a generar
        sanciones
        penales y administrativas conforme a las leyes aplicables. Igualmente, cada Prestador en sus t&eacute;rminos y
        condiciones determinar&aacute; las medidas tendientes a prevenir cualquiera de estas conductas tipificadas como
        delitos en las leyes.</span></div>
    <h4>X. LICENCIAS Y MARCAS REGISTRADAS</h4>
    <div><span>1. Rappi Travel
        opera a trav&eacute;s de la plataforma Rappi de propiedad de RAPPI INC. quien posee las autorizaciones
        correspondientes para el uso de las im&aacute;genes, gr&aacute;ficas, iconos, caracteres, m&uacute;sica, textos,
        software, videos y otros contenidos de la plataforma Rappi (en adelante, &quot;contenido&quot;), as&iacute; como
        de
        las codificaciones HTML, CGI, WS y otros c&oacute;digos y textos en cualquier formato (en adelante,
        &quot;c&oacute;digo&quot;) utilizados para implementar la plataforma Rappi.</span></div>
    <div><span>2. Ning&uacute;n
        c&oacute;digo o contenido de la plataforma Rappi podr&aacute; ser modificado, alterado, copiado, distribuido,
        retransmitido, expuesto, utilizado, reproducido y/o publicado bajo ning&uacute;n concepto.</span></div>
    <div><span>3. Cualquier
        modificaci&oacute;n o uso del contenido o c&oacute;digo de la plataforma Rappi para prop&oacute;sitos diferentes
        a
        los permitidos expresamente por Rappi S.A.S. o por Brisanier S.A., constituye una violaci&oacute;n de las leyes
        de
        derechos de autor (Copyright) y otros derechos de propiedad intelectual, as&iacute; como a las normas penales a
        que
        d&eacute; lugar la situaci&oacute;n particular.</span></div>
    <p><span>CONSIDERACIONES
        ESPEC&Iacute;FICAS DE LOS SERVICIOS TUR&Iacute;STICOS</span></p>
    <p><span>I. VUELOS</span></p>
    <p><span>● Para efectos de
        esta secci&oacute;n, por Aerol&iacute;nea se entender&aacute; a la compa&ntilde;&iacute;a encargada de prestar
        el
        servicio de transporte a&eacute;reo adquirido por el Usuario/Consumidor por medio del bot&oacute;n &quot;Rappi
        Travel&quot; dentro de la plataforma Rappi.</span></p>
    <div><span>1. Respecto de las
        tarifas promocionales, econ&oacute;micas y turistas: A trav&eacute;s del bot&oacute;n &quot;Rappi Travel&quot;
        dentro de la plataforma Rappi, siempre se mostrar&aacute; la disponibilidad de las tarifas m&aacute;s
        econ&oacute;micas encontradas a trav&eacute;s del sistema de distribuci&oacute;n GDS o sistemas de
        conexi&oacute;n
        de la l&iacute;nea a&eacute;rea en caso que aplique. Por lo anterior, dichas tarifas contienen mayor
        restricciones
        en las pol&iacute;ticas de cambios, cancelaciones y reembolso, entendi&eacute;ndose que en caso de que el
        Usuario/Consumidor y/o el Pasajero soliciten alguno de los procesos anteriormente mencionados, se podr&aacute;n
        generar sobrecostos, los cuales deber&aacute; ser asumidos por &eacute;stos. Se aclara que Rappi Travel no se
        encuentra autorizada a modificar en ning&uacute;n caso las regulaciones de los&nbsp;</span><span>tickets
        a&eacute;reos</span><span>.</span></div>
    <div><span>2.
        Gastos</span><span>&nbsp;Administrativos: Los Gastos Administrativos son cobrados por
        Pasajero, se aclara que los mismos no son reembolsables y el Usuario no tendr&aacute; derecho a reclamo para la
        devoluci&oacute;n de los mismos.</span></div>
    <div><span>3.
        Cancelaci&oacute;n gratuita: Los tickets a&eacute;reos que sean gestionados a trav&eacute;s de un GDS
        podr&aacute;n
        ser cancelados gratuitamente el mismo d&iacute;a de su compra siempre que la solicitud se presente en correcta
        forma
        antes de las 11:45 p.m.&nbsp;</span><span>hora Uruguaya.</span><span>&nbsp;En caso de que este tipo de
        cancelaci&oacute;n proceda se informar&aacute; en el
        proceso de compra la posibilidad. Esta cancelaci&oacute;n procede siempre que el ticket no se encuentre en
        estado de
        &ldquo;Check-in&rdquo;. Debe aclararse que el t&eacute;rmino para realizar el Check-in depende de las
        pol&iacute;ticas internas de cada aerol&iacute;nea, el Usuario/Consumidor deber&aacute; consultar dichas
        pol&iacute;ticas con la aerol&iacute;nea correspondiente. Esta cancelaci&oacute;n debe ser realizada por el
        Usuario/Consumidor a trav&eacute;s de la secci&oacute;n &ldquo;Mis Viajes&rdquo; seleccionando el viaje
        adquirido
        ese d&iacute;a. Una vez el Usuario/Consumidor realice la cancelaci&oacute;n gratuita se reembolsar&aacute; el
        valor
        pagado al mismo medio en el cual realiz&oacute; el pago, este reembolso tomar&aacute; entre quince (15. y veinte
        (20) d&iacute;as h&aacute;biles dependiendo de la entidad bancaria.</span></div>
    <div><span>4. Desistimiento
        para tickets a&eacute;reos: El Usuario/Consumidor podr&aacute; desistir del viaje dando aviso a la
        Aerol&iacute;nea
        o a Rappi Travel con un plazo de al menos veinticuatro (24) horas calendario antes del inicio de vuelo. Se
        aclara
        que este derecho s&oacute;lo puede ser ejercido por el Usuario/consumidor. En este caso, la Aerol&iacute;nea
        aplicar&aacute; una retenci&oacute;n de acuerdo con la regla tarifaria aplicable sin que &eacute;sta exceda el
        diez
        por ciento (10%) del valor de la tarifa base incluyendo el Q de Combustible. El desistimiento no aplica para las
        tarifas promocionales, y el reembolso se har&aacute; efectivo dentro de los treinta (30) d&iacute;as siguientes
        a la
        fecha de notificaci&oacute;n a la forma original de pago.</span></div>
    <div><span>5. Retrasos,
        modificaciones y/o cancelaciones de vuelos por las aerol&iacute;neas: El Usuario/Consumidor acepta y reconoce
        que
        las aerol&iacute;neas est&aacute;n habilitadas a realizar modificaciones en los vuelos programados en tanto las
        comunique a la autoridad, conforme a la regulaci&oacute;n aplicable. En relaci&oacute;n con lo anterior, se
        aclara
        que Rappi Travel no interviene en las modificaciones que podr&iacute;an sufrir los vuelos, entendi&eacute;ndose
        que,
        en caso de presentarse alguna variaci&oacute;n en los mismos, Rappi Travel le informar&aacute; al
        Usuario/Consumidor
        las alternativas disponibles y solo proceder&aacute; a confirmar las modificaciones con su aceptaci&oacute;n.
        Cualquier reclamo, demanda o denuncia por la prestaci&oacute;n del servicio escogido deber&aacute; ser dirigida
        a la
        Compa&ntilde;&iacute;a A&eacute;rea. Recuerde que son las aerol&iacute;neas las que prestan el servicio de
        transporte. Los derechos del Usuario/Consumidor y los procedimientos para hacer efectivas las devoluciones de
        dinero
        a que estos hechos den lugar, se regir&aacute;n por las disposiciones legales pertinentes y en particular, por
        las
        contenidas en&nbsp;</span><span>la Ley N&deg; 17250 - Ley de Relaciones de &nbsp;Consumo -
        Defensa del Consumidor y lo informado por Direcci&oacute;n Nacional de Aviaci&oacute;n Civil e Infraestructura
        Aeron&aacute;utica (DINACIA).&nbsp;</span><span>Cuando por raz&oacute;n de la tarifa o por
        cualquier otro motivo existan restricciones para efectuar modificaciones a la reserva a&eacute;rea, endosos o
        reembolsos; tales limitaciones se informar&aacute;n en su momento al Usuario/Consumidor.</span></div>
    <div><span>6. El
        tr&aacute;mite del reembolso de un ticket lo realiza la Aerol&iacute;nea y el tiempo estimado de reintegro
        depende
        de &eacute;sta, siempre y cuando el ticket a&eacute;reo sea reembolsable. En caso de reembolso, se
        aplicar&aacute;n
        las normas y penalidades establecidas por cada Aerol&iacute;nea con base en el tipo de tarifa y sus
        restricciones.
        As&iacute; mismo, en el supuesto que el Usuario/Consumidor solicite la cancelaci&oacute;n y el reembolso del o
        los
        tickets, Rappi Travel podr&aacute; cobrar un cargo de gesti&oacute;n adicional, el cual se realizar&aacute; por
        ticket a procesar.</span></div>
    <div><span>7. Algunas tarifas
        econ&oacute;micas no permiten cambios, cancelaciones ni devoluciones, en caso en que -de acuerdo con la
        reglamentaci&oacute;n dispuesta por la l&iacute;nea a&eacute;rea- la tarifa seleccionada por el
        Usuario/Consumidor&nbsp;</span><span>permita</span><span>&nbsp;cambios, cancelaciones y/o devoluciones, la
        Aerol&iacute;nea podr&aacute; aplicar
        cobros adicionales tales como penalidades y diferencia de tarifa (resultado de la diferencia entre la tarifa
        originalmente comprada y la nueva tarifa seg&uacute;n disponibilidad al momento de efectuar el cambio). Se
        aclara
        que los cambios se deben realizar en las mismas clases emitidas o bien en clases superiores. En caso de
        cancelaci&oacute;n y reembolso, Rappi Travel realizar&aacute; la gesti&oacute;n y seguimiento de la solicitud
        frente
        a la Aerol&iacute;nea y el Usuario/Consumidor. Adem&aacute;s, tanto en el caso de cambios como de cancelaciones,
        Rappi Travel podr&aacute; cobrar un cargo de gesti&oacute;n adicional.</span></div>
    <div><span>8. En el servicio
        a&eacute;reo se considera menor a una persona que a la fecha de viaje no haya cumplido los 12 a&ntilde;os de
        edad.
        Con base en lo anterior, se informa a continuaci&oacute;n la clasificaci&oacute;n de ni&ntilde;os en el
        transporte
        a&eacute;reo con base a su edad: - Infantes: Es todo aquel ni&ntilde;o que no ha cumplido los dos (2.
        a&ntilde;os a
        la fecha de vuelo, y viaja sin ocupar silla. Se aclara que el infante debe estar siempre acompa&ntilde;ado por
        un
        adulto, y debe ser cargado en todo momento por el adulto responsable. Al infante le ser&aacute; emitido un
        ticket,
        aunque &eacute;ste no haya pagado tarifa alguna en vuelos dom&eacute;sticos. En tal caso que el adulto desee que
        infante ocupe asiento, &eacute;ste deber&aacute; realizar el pago del boleto de transporte a&eacute;reo y
        deber&aacute; llevar una silla de infante aprobada por las normas internacionales como apta para usarse en una
        aeronave. - Ni&ntilde;os: Son aquellos ni&ntilde;os que ya han cumplido los dos (2. a&ntilde;os de edad y no han
        cumplido los doce (12) a&ntilde;os a la fecha del vuelo, los ni&ntilde;os entre estas edades ocupan asiento y
        pagan
        la tarifa informada por la Aerol&iacute;nea.</span></div>
    <div><span>9. Se
        considerar&aacute; &quot;menor no acompa&ntilde;ado&quot; a aquel que viaje sin al menos uno de sus padres
        leg&iacute;timos o naturales o tutores leg&iacute;timos, dativos o testamentarios. Las aerol&iacute;neas pueden
        ofrecer servicios de asistencia y acompa&ntilde;amiento (con costo) que, seg&uacute;n el caso, podr&aacute;n ser
        obligatorios u opcionales para aquellos menores que viajen sin acompa&ntilde;ante. Sin embargo, Rappi Travel no
        ofrece este tipo de servicios y no podr&aacute; asegurar el efectivo embarque del menor en el caso de que la
        exigencia fuera obligatoria. Los menores de entre 2 y 5 a&ntilde;os, deber&aacute;n viajar obligatoriamente
        acompa&ntilde;ados por sus padres o responsables a cargo. Normalmente el servicio de &quot;menor no
        acompa&ntilde;ado&quot; es obligatorio para ni&ntilde;os de entre 5 y 11 a&ntilde;os, y opcional para
        ni&ntilde;os
        de entre 12 y 17 a&ntilde;os. El servicio no est&aacute; disponible para ni&ntilde;os que requieran
        certificaci&oacute;n m&eacute;dica para viajar, que no puedan alimentarse y/o que no sean capaces de cubrir sus
        necesidades b&aacute;sicas de higiene, y no est&aacute; disponible para itinerarios con escalas o cambios de
        avi&oacute;n. El Usuario/Consumidor y el Pasajero son responsables de consultar la pol&iacute;tica
        espec&iacute;fica
        de la aerol&iacute;nea.</span></div>
    <div><span>10. De acuerdo con
        lo establecido en el art&iacute;culo 19310 del C&oacute;digo de la Ni&ntilde;ez y la Adolescencia, Rappi Travel
        informa lo siguiente:</span><span><br></span><span>&quot;Los
        ni&ntilde;os y adolescentes que viajen solos o en compa&ntilde;&iacute;a de terceros fuera del pa&iacute;s
        necesitan
        consentimiento de ambos &nbsp;padres o del representante legal en su caso. En caso de separaci&oacute;n o
        divorcio
        de los padres, se requerir&aacute; la autorizaci&oacute;n de ambos.(...)Cuando un ni&ntilde;o, una ni&ntilde;a o
        un
        adolescente que tiene residencia en Uruguay vaya a salir del pa&iacute;s con uno de los padres o con una persona
        distinta a los representantes legales deber&aacute; obtener previamente el permiso de aquel con quien no viajare
        o
        el de aquellos, debidamente autenticado ante notario o autoridad consular. Dicho permiso deber&aacute; contener
        el
        lugar de destino, el prop&oacute;sito del viaje y la fecha de salida e ingreso de nuevo al
        pa&iacute;s.&quot;</span><span><br></span><span>11. Los servicios
        especiales son aquellos servicios que se brindan con base en las necesidades del Usuario/Consumidor o del
        Pasajero
        (en adelante &quot;Servicios Especiales&quot;). Dentro de la categor&iacute;a de Servicios Especiales se
        incluye,
        entre otros, el servicio de silla de ruedas, alimentaci&oacute;n especial abord&oacute;, mascotas en cabina y
        bodega, y menores sin acompa&ntilde;ante. Dichos Servicios Especiales deben ser solicitados por el
        Usuario/Consumidor a Rappi Travel con m&iacute;nimo setenta y dos (72) horas calendario de antelaci&oacute;n a
        la
        fecha del vuelo. Se aclara que los Servicios Especiales est&aacute;n sujetos a confirmaci&oacute;n por parte de
        las
        Aerol&iacute;neas con base en la disponibilidad, y en algunas ocasiones, estos Servicios Especiales pueden
        generar
        costos adicionales.</span></div>
    <div><span>12. Las
        aerol&iacute;neas tienen diferentes pol&iacute;ticas de franquicia de equipaje. Lo usual en los vuelos
        nacionales es
        de 8 kg y en los internacionales de 23 kg. Sin embargo, esto puede variar seg&uacute;n la aerol&iacute;nea, y la
        clase en que viaje el pasajero, entendi&eacute;ndose que algunas tarifas no incluyen franquicia de equipaje.
        Rappi
        Travel no se responsabiliza por robo, hurto y/o p&eacute;rdida de equipaje y dem&aacute;s efectos personales de
        los
        pasajeros. En caso de p&eacute;rdida o deterioro de equipaje, el Pasajero debe dirigirse a las oficinas de
        atenci&oacute;n al cliente de la Aerol&iacute;nea y realizar el correspondiente reclamo. En todo caso el
        Usuario/Consumidor y el Pasajero deber&aacute;n informarse sobre esto antes de viajar.</span></div>
    <div><span>13. Si el
        Usuario/Consumidor no se presenta a utilizar su reserva en la fecha y horarios indicados (o llega con retraso),
        el
        Usuario/Consumidor no tendr&aacute; derecho a exigir la devoluci&oacute;n total o parcial del importe abonado
        (en
        adelante &quot;No Show&quot;). Igualmente, si el Usuario/Consumidor no va a utilizar su reserva en todo o en
        parte o
        si va a llegar con retraso a utilizar su reserva, deber&aacute; comunicarlo previamente a Rappi Travel para
        conocer
        las restricciones aplicables.</span></div>
    <div><span>14. El
        Usuario/Consumidor deber&aacute; abstenerse de generar m&aacute;s de una reserva para el mismo destino-
        pasajero-
        fecha - hora y Aerol&iacute;nea. Esto se considera una mala pr&aacute;ctica de duplicidad que puede ocasionar
        una
        cancelaci&oacute;n de reserva por parte de la aerol&iacute;nea.</span></div>
    <div><span>15. Los tickets
        &quot;SOLO IDA&quot;: Por disposiciones migratorias de cada pa&iacute;s, en caso de que el Pasajero tenga un
        ticket
        ticket &uacute;nicamente de ida, y &eacute;ste no sea residente del pa&iacute;s de destino, podr&aacute; ser
        requerido por las autoridades migratorias a justificar las razones por las que no cuenta con un ticket de
        regreso.
        En ese caso, el Usuario/Consumidor deber&aacute; consultar al Consulado o Embajada correspondiente antes de
        efectuar
        la reserva. Las aerol&iacute;neas tambi&eacute;n podr&aacute;n exigir esta documentaci&oacute;n antes de
        embarcar.</span></div>
    <div><span>16. La
        responsabilidad en el transporte a&eacute;reo se encuentra regulada por la&nbsp;</span><span>Direcci&oacute;n
        Nacional de Aviaci&oacute;n Civil e Infraestructura Aeron&aacute;utica
        (DINACIA)</span><span>. En virtud de lo anterior, si el Usuario/Consumidor desea realizar
        un reclamo respecto del contrato de transporte a&eacute;reo celebrado entre &eacute;ste y la
        Aerol&iacute;nea,&nbsp;</span><span>puede efectuarlo ante la DINACIA,&nbsp;</span><a
        href="http://www.dinacia.gub.uy/"><u><span>www.dinacia.gub.uy/</span></u></a><span>, organismo encargado
        de regular, vigilar, fiscalizar y certificar la actividad
        aeron&aacute;utica comercial en Uruguay.</span></div>
    <p><span>II. HOTELES</span>
    </p>
    <div><span>1. Las tarifas
        hoteleras exhibidas en el bot&oacute;n &quot;Rappi Travel&quot; dentro de la plataforma Rappi estar&aacute;n
        sujetas
        a la acomodaci&oacute;n seleccionada por el Usuario/Consumidor. Las pol&iacute;ticas de cancelaci&oacute;n,
        penalidades y restricciones aplicables a la reserva o paquete que desea adquirir el Usuario/Consumidor,
        ser&aacute;n
        definidas por parte del Prestador.</span></div>
    <div><span>2. La
        informaci&oacute;n espec&iacute;fica del servicio hotelero como nombre, ubicaci&oacute;n, categorizaci&oacute;n,
        horarios de check-in y check-out, y servicios incluidos se encuentra suficientemente detallada en la plataforma
        Rappi. Los Prestadores son responsables exclusivos de actualizar las tarifas, la disponibilidad y los otros
        datos
        que aparecen en la plataforma Rappi.</span></div>
    <div><span>3. Recuerde que, si
        el Usuario/Consumidor no se presenta en el alojamiento en la fecha y horario correspondientes, el alojamiento
        podr&aacute; cancelar su reserva y considerarla como No Show. En dicho caso, el Usuario/Consumidor no
        tendr&aacute;
        derecho a exigir el reembolso total o parcial del importe abonado. Si por alguna circunstancia el
        Usuario/Consumidor
        va a llegar fuera de los horarios indicados, debe comunicarse previamente con el alojamiento y/o con Rappi
        Travel.</span></div>
    <div><span>4. El
        Usuario/Consumidor podr&aacute; solicitar cambios y/o cancelaciones siempre que las condiciones y
        pol&iacute;ticas
        de la tarifa adquirida lo permita. Cualquier excepci&oacute;n a dichas condiciones deber&aacute; ser autorizada
        por
        el alojamiento. Rappi Travel no se encuentra autorizada a modificar en ning&uacute;n caso las pol&iacute;ticas
        y/o
        condiciones de la reserva.</span></div>
    <div><span>5.&nbsp;</span><span>Los extranjeros no residentes en Uruguay
        est&aacute;n exentos de tasas/impuestos hoteleros en Uruguay por el periodo de 2024, este comunicado se
        encuentra en
        la pagina web del Ministerio de Turismo,
        &nbsp;https://www.gub.uy/ministerio-turismo/comunicacion/comunicados/beneficios-para-no-residentes. En virtud de
        lo
        anterior, &eacute;stos s&oacute;lo tendr&aacute;n que pagar el seguro hotelero el cual es opcional, y en caso
        de&nbsp;</span><span>requerirlo</span><span>, deber&aacute;n
        efectuar el pago del mismo al alojamiento directamente. Por el contrario,
        los&nbsp;</span><span>Pasajeros</span><span>&nbsp;colombianos deben pagar en el
        alojamiento las tasas y el seguro hotelero opcional en caso de contratarlo. Esta validaci&oacute;n se
        realizar&aacute; directamente en el alojamiento.</span></div>
    <div><span>7. Rappi Travel
        informa que la actividad de los alojamientos domiciliados en</span><span>&nbsp;la
        Rep&uacute;blica Oriental del Uruguay se encuentra regulada por la Ley de Turismo - Ley N&deg;
        18.829,</span><span>&nbsp;su y sus decretos reglamentarios, normativas municipales, y las normativas de
        seguridad e higiene. Adem&aacute;s de las disposiciones especiales establecidas por
        el&nbsp;</span><span>Ministerio
        de Turismo, y dem&aacute;s autoridades regulatorias y de defensa del consumidor
        uruguayo.</span><span>&nbsp;Si el Usuario/Consumidor desea realizar un reclamo respecto del
        servicio brindado por el alojamiento, puede efectuarlo directamente ante los organismos previamente expuestos.
        P</span><span>ara esto, puede ingresar a: www.tramites.mintur.gub.uy/</span></div>
    <div><span>8. Rappi Travel
        podr&aacute; solicitar una opini&oacute;n o rese&ntilde;a al Usuario/Consumidor una vez este haya utilizado los
        servicios de alojamiento, y est&aacute; podr&aacute; ser publicada, siempre y cuando, no incumpla con alguna de
        las
        siguientes condiciones: a) Haga menci&oacute;n a t&eacute;rminos discriminatorios o racistas; b) Utilice
        lenguaje
        ofensivo, violento o malintencionado; c) Realice amenazas en contra de Rappi Travel, su matriz, subsidiarias y/o
        filiales, del alojamiento, su personal o de otro Usuario/Consumidor; d) Utilice expresiones obscenas o
        sexualmente
        expl&iacute;citas;&nbsp;</span><span>y e</span><span>) Exponga
        informaci&oacute;n como p&aacute;ginas web, n&uacute;meros de tel&eacute;fono, direcciones de correo
        electr&oacute;nico datos de tarjeta de cr&eacute;dito o informaci&oacute;n personal privada.</span></div>
    <p><span>III. Vuelo +
        Hote</span><span>l</span></p>
    <div><span>1. A trav&eacute;s
        de la secci&oacute;n denominada &quot;Vuelo + Hotel &quot; dentro del bot&oacute;n &quot;Rappi Travel&quot; en
        la
        plataforma Rappi, el Usuario/Consumidor puede armar su viaje de manera aut&oacute;noma y din&aacute;mica,
        sumando
        cada uno de los servicios que el Usuario/Consumidor desee tomar y tendr&aacute; la posibilidad de adquirir los
        diversos productos tur&iacute;sticos seleccionados en un &uacute;nico proceso de compra. y un &uacute;nico pago.
        Rappi Travel act&uacute;a como una agencia de viajes intermediaria, que a trav&eacute;s de la Plataforma Rappi
        permite que los Prestadores exhiban, ofrezcan y comercialicen sus Servicios Tur&iacute;sticos para que los
        Usuarios/Consumidores elijan dentro de las Servicios Tur&iacute;sticos exhibidos por los Prestadores as
        combinaciones de los Servicios Tur&iacute;sticos que se ajusten a sus necesidades.</span></div>
    <div><span>2. Rappi Travel no
        asesora ni promueve que los Usuarios/Consumidores adquieran Servicios Tur&iacute;stico de un Prestador
        espec&iacute;fico; los Usuarios/Consumidores a trav&eacute;s del bot&oacute;n Vuelo + Hotel pueden armar su
        propio
        Servicio Tur&iacute;stico seleccionando dentro de las alternativas de hoteles y vuelos disponibles exhibidos,
        ofrecidos y comercializados por nuestros Prestadores. Los Usuarios/Consumidores antes de realizar el pago
        podr&aacute;n modificar cualquiera de los Servicios Tur&iacute;sticos seleccionados por uno que se adapte mejor
        a
        sus necesidades. Rappi Travel no act&uacute;a como organizador ni es quien elige o combina los Servicios
        Tur&iacute;sticos.</span></div>
    <div><span>3. Cada Servicio
        Tur&iacute;stico seleccionado por los Usuarios/Consumidores para armar su paquete de Vuelo + Hotel, establece
        sus
        propias condiciones de cambio y/o cancelaci&oacute;n definidas por cada Prestador. Por lo anterior, cualquier
        modificaci&oacute;n y/o cancelaci&oacute;n de uno de los Servicio Tur&iacute;stico no afecta a los otros
        Servicios
        Tur&iacute;sticos adquiridos por los Usuarios/Consumidores, los cuales se regir&aacute;n por sus propias
        condiciones, y deber&aacute;n ser modificados y/o cancelados individualmente siempre que las condiciones
        establecidas por los Prestadores lo permitan.</span></div>
    <div><span>4. Es
        responsabilidad de los Usuarios/Consumidores la verificaci&oacute;n con relaci&oacute;n a la obligatoriedad de
        presentar una tarjeta de asistencia m&eacute;dica de acuerdo al Servicio Tur&iacute;stico Vuelo + Hotel
        adquirido.
        Por lo tanto, el Usuario/Consumidor deber&aacute; presentar la tarjeta de asistencia m&eacute;dica al ingreso de
        la
        ciudad y/o pa&iacute;s. Lo anterior, porque algunos pa&iacute;ses exigen como requisito de ingreso obligatorio
        la
        presentaci&oacute;n de una tarjeta de asistencia m&eacute;dica, es responsabilidad de los Usuarios/Consumidores
        validar los requisitos y documentaci&oacute;n necesaria para el ingreso al pa&iacute;s o ciudad de destino.
        Rappi
        Travel no es responsable si en el pa&iacute;s de destino no se le permite el ingreso al Usuario/Consumidor o
        Consumidor final por la falta de documentaci&oacute;n requerida.</span></div>
    <p><span>IV.
        ACTIVIDADES</span></p>
    <div><span>1. Se entienden por
        &quot;Actividades&quot; la contrataci&oacute;n de excursiones, traslados o atracciones, entre otras
        que&nbsp;</span><span>ofrezcan</span><span>&nbsp;los
        Prestadores.</span></div>
    <div><span>2. Las Actividades
        pueden sufrir modificaciones en horarios y puntos de partida. Es responsabilidad del Usuario/Consumidor
        confirmar
        con previa anticipaci&oacute;n esta informaci&oacute;n con el Prestador. La informaci&oacute;n de contacto
        estar&aacute; disponible en el voucher de confirmaci&oacute;n. Rappi Travel no ser&aacute; responsable por la
        omisi&oacute;n de este procedimiento por parte del Usuario/Consumidor.</span></div>
    <div><span>3. En los casos en
        los que una Actividad contratada sea una de riesgo, el Usuario/Consumidor asume el riesgo de participar en la
        Actividad.</span></div>
    <p><span>V. ALQUILER DE
        AUTOS</span></p>
    <div><span>1. El servicio de
        alquiler de auto se ofrecer&aacute; dentro del bot&oacute;n &quot;Rappi Travel&quot;. El periodo de
        duraci&oacute;n
        del servicio depender&aacute; de las fechas seleccionadas por el Usuario/Consumidor en el proceso de
        compra.</span>
    </div>
    <div><span>2. La tarifa de
        alquiler de auto incluye kilometraje ilimitado y seguros m&iacute;nimos requeridos en el destino. Los servicios
        adicionales requeridos por el Usuario/Consumidor deber&aacute;n ser agregados a la compra. Se entiende por
        servicios
        adicionales, entre otros, GPS, Wifi, seguros/coberturas adicionales, entre otros.</span></div>
    <div><span>3. La tarifa de
        alquiler de auto no incluye impuestos o tasas locales a menos que sea expl&iacute;citamente informado por el
        Prestador, as&iacute; como tampoco el pago de multas, infracciones, servicio de gr&uacute;as, combustible,
        entrega
        de auto en otra ciudad, peajes ni cualquier otro servicio adicional, a menos que este haya sido contratado con
        el
        Prestador.</span></div>
    <div><span>4. Se
        aplicar&aacute;n las condiciones y requisitos de edad, permisos y calificaci&oacute;n crediticia vigentes y
        necesarias para la prestaci&oacute;n del servicio de alquiler de auto. Cada Prestador especificar&aacute; estas
        condiciones, las cuales deben ser consultadas por el Usuario/Consumidor.</span></div>
    <div><span>5. La reserva de un
        auto a trav&eacute;s del bot&oacute;n &quot;Rappi Travel&quot; dentro de la plataforma Rappi, se realiza para
        una
        clase de auto, no para veh&iacute;culos de marcas, a&ntilde;os o modelos espec&iacute;ficos.</span></div>
    <div><span>6. Las solicitudes
        de cambios o cancelaciones estar&aacute;n sujetas a las pol&iacute;ticas informadas por el Prestador. Estas
        solicitudes deber&aacute;n ser notificadas a Rappi Travel con una anticipaci&oacute;n no menos de veinticuatro
        (24)
        horas antes de la fecha de iniciaci&oacute;n del alquiler.</span></div>
    <div><span>7. El
        Usuario/Consumidor deber&aacute; presentar una tarjeta de cr&eacute;dito a nombre del conductor. El Prestador
        podr&aacute; realizar un bloqueo correspondiente al monto de la garant&iacute;a. Igualmente, &eacute;ste
        podr&aacute; negar la prestaci&oacute;n del servicio de alquiler de auto en caso de no presentarse la
        garant&iacute;a mediante tarjeta de cr&eacute;dito.</span></div>
    <div><span>8. La
        intermediaci&oacute;n prestada por parte de Rappi Travel en lo referente al alquiler o renta de
        autom&oacute;viles
        en la&nbsp;</span><span>Rep&uacute;blica Oriental del Uruguay, est&aacute; regulada por un
        conjunto de normas, entre ellas, el C&oacute;digo Civil, el C&oacute;digo de Comercio, la Ley 17.250 de
        Relaciones
        de Consumo - Defensa del COonsumidor, adem&aacute;s de las disposiciones especiales establecidas por el
        Ministerio
        de Turismo y las dem&aacute;s autoridades regulatorias.</span></div>
    <p><span>VI. TRANSPORTE
        TERRESTRE Y/O BUSES</span></p>
    <p><span>● Para efectos de
        esta secci&oacute;n Empresa de Autobuses ser&aacute; aquella que contrata el Usuario/Consumidor para la
        prestaci&oacute;n del servicio de transporte terrestre o autob&uacute;s.</span></p>
    <div><span>1. Una vez
        confirmada la solicitud de compra por medio de correo electr&oacute;nico, el Usuario/Consumidor recibir&aacute;
        a su
        correo electr&oacute;nico registrado en la plataforma Rappi, el voucher del Servicio Tur&iacute;stico, el cual
        deber&aacute; imprimir y llevar a la terminal de transporte. Al momento de viajar, el Pasajero debe recoger el
        boleto en el mostrador del Prestador, el cual para efectos de esta secci&oacute;n se denominar&aacute;
        &quot;Empresa
        Transportadora&quot;. Se aclara que este proceso deber&aacute; ser realizado por el Pasajero antes de abordar.
        Igualmente, se aclara que el Pasajero deber&aacute; presentarse en el mostrador, por regla general, con una
        antelaci&oacute;n de m&iacute;nimo una (1. hora sobre el horario de salida previsto, entendi&eacute;ndose que en
        caso de no presentarse y/o no presentarse con el tiempo suficiente, el Usuario/Consumidor y el Pasajero no
        tendr&aacute;n derecho a exigir el reembolso total o parcial del importe abonado. El Usuario/Consumidor y el
        Pasajero deber&aacute;n consultar las exigencias de la Empresa de Autobuses contratada.</span></div>
    <div><span>2. Adicionalmente,
        el Pasajero deber&aacute; contar con la documentaci&oacute;n de viaje requerida. En caso de que los datos
        registrados en el boleto no coincidan con la documentaci&oacute;n de viaje que se presenta antes de subir al
        autob&uacute;s, el pasajero no podr&aacute; viajar. Las Empresas de Autobuses se reservan el derecho de brindar
        el
        Servicio Tur&iacute;stico adquirido mediante otra empresa cuando por razones t&eacute;cnicas u operativas, se
        vean
        imposibilitadas a hacerlo con sus unidades. Sin perjuicio de lo anterior, las Empresas de Autobuses deben
        respetar
        el precio, calidad y categor&iacute;a de servicio adquirida por el Usuario/Consumidor, salvo que la
        modificaci&oacute;n se presente con ocasi&oacute;n de un evento de fuerza mayor o caso fortuito.</span></div>
    <div><span>4. Franquicia de
        Equipaje: Las Empresas Transportadoras tienen diferentes pol&iacute;ticas de franquicia de equipaje. Estas
        podr&aacute;n variar seg&uacute;n la Empresa Transportadora y la clase en que se viaje, algunas tarifas no
        incluyen
        franquicia de equipaje. El Usuario/Consumidor deber&aacute; consultarlas antes de viajar.</span></div>
    <div><span>5. Rappi Travel no
        se hace responsable por p&eacute;rdida o da&ntilde;os sufridos por objetos de valor extraordinario que el
        Pasajero
        lleve consigo. Las Empresas Transportadoras tampoco son responsables por la p&eacute;rdida de equipaje de mano y
        de
        los dem&aacute;s efectos personales que hayan quedado bajo la custodia del Pasajero, salvo culpa de la Empresa
        Transportadora.</span></div>
    <div><span>6. Por
        disposiciones migratorias de cada pa&iacute;s, en caso de que el Pasajero cuente con un pasaje &uacute;nicamente
        de
        ida, y &eacute;ste no sea residente del pa&iacute;s de destino, podr&aacute; ser requerido por las autoridades
        migratorias a justificar las razones por las que no cuenta con un pasaje de regreso. El Usuario/Consumidor
        deber&aacute; consultar al Consulado o Embajada correspondiente antes de efectuar la reserva.</span></div>
    <p><span>VII.&nbsp;</span><span>CESI&Oacute;N Y TRANSFERENCIA:</span><span>&nbsp;el derecho que confiere al cliente
        el
        contrato de servicios tur&iacute;sticos
        podr&aacute; ser cedido o transferido a otras personas hasta 30 d&iacute;as antes de la fecha de salida, siempre
        que
        no se opongan a ello las prescripciones del transportista, del hotelero o del prestador de los servicios. En los
        supuestos que los pasajeros sean de distintas edades (mayores-menores), se ajustar&aacute; el precio tarifas
        vigentes al momento de la solicitud. En todos los casos de cesi&oacute;n o transferencia, Rappi Travel
        podr&aacute;
        percibir un cargo del 10% del monto convenido. Por normas internacionales de seguridad, los billetes que
        conforman
        el contrato de transporte a&eacute;reo y/o mar&iacute;timo no son cedibles a terceros, como tampoco todos
        aquellos
        servicios que por disposici&oacute;n del prestador no permitan tal cesi&oacute;n.</span></p>
    <p><span>VIII.&nbsp;</span><span>RESPONSABILIDAD:</span></p>
    <div>1.&nbsp;<span>Esta
        empresa podr&aacute; actuar como organizadora o intermediaria, seg&uacute;n el caso; ser&aacute; intermediaria
        en la
        reserva o contrataci&oacute;n de los distintos servicios vinculados e incluidos en el respectivo tour o
        reservaci&oacute;n de servicios: hoteles, restaurantes, medios de transportes u otros prestadores.&nbsp;</span>
    </div>
    <div>2.&nbsp;<span>Esta
        compa&ntilde;&iacute;a no es responsable por los hechos fortuitos o de fuerza mayor, fen&oacute;menos
        clim&aacute;ticos, de la naturaleza y pand&eacute;micos, situaciones de conflicto b&eacute;lico que acontezcan
        previo o durante el desarrollo del tour y que impidan, demoren o de cualquier modo obstaculicen la
        ejecuci&oacute;n
        total o parcial de las prestaciones comprometidas por esta empresa, todo ello de conformidad con las
        disposiciones
        del C&oacute;digo Civil y del C&oacute;digo de Comercio de la Naci&oacute;n. Rappi Travel informar&aacute; al
        pasajero en caso de situaciones de conflicto que pudiere atravesar el lugar de destino y, el pasajero,
        debidamente
        informado, decidir&aacute; personalmente si llevar a cabo o no el viaje. Se deja a salvo que todo viaje queda
        supeditado a las disposiciones sanitarias y/o migratorias del pa&iacute;s de origen y destino de cada viaje en
        el
        momento preciso en que deba iniciar o finalizar el viaje. Se deja expresa constancia que esta
        compa&ntilde;&iacute;a
        no conforma ning&uacute;n grupo econ&oacute;mico ni tiene asociaci&oacute;n alguna con empresas navieras,
        l&iacute;neas a&eacute;reas, hoteles ni organizadoras de excursiones, concursos, promociones, resorts u otros
        organizadores de tours, en el pa&iacute;s ni en el exterior, como tampoco con Rappi Travel minorista de viajes
        que
        comercialice sus servicios y/o productos.</span></div>
    <div>3.&nbsp;<span>Los
        pasajeros deben obligatoriamente contratar asistencia al viajero acorde con su rango etario y
        geolocalizaci&oacute;n
        del destino elegido. De no hacerlo, se entiende que asumen en forma personal todos los riesgos de cualquier
        naturaleza que se&nbsp;</span><span>pudiesen</span><span>&nbsp;presentar sobre su persona, sus bienes y/o de
        terceros. Toda asistencia al viajero,
        aun la que no se contrate a trav&eacute;s de la intermediaci&oacute;n de esta agencia de viajes debe amparar la
        contingencia &ldquo;pandemia&rdquo; por asistencia y cancelaci&oacute;n o suspensi&oacute;n del
        viaje.&nbsp;</span>
    </div>
    <div>4.&nbsp;<span>Los datos
        personales contenidos en las reservas de viaje contratadas a trav&eacute;s de esta empresa son tratados conforme
        establece la Ley 18.331 y ser&aacute;n conservados el menor tiempo necesario. S&oacute;lo ser&aacute;n
        divulgados
        aquellos datos indispensables para concretar las reservas de los servicios elegidos. En materia de datos
        personales:
        el titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma
        gratuita
        a intervalos no inferiores a seis meses, salvo que acredite un inter&eacute;s leg&iacute;timo.
        La&nbsp;</span><span>Unidad Reguladora y de Control de Datos Personales</span><span>&nbsp;tiene la
        atribuci&oacute;n
        de atender las denuncias y reclamos que se interpongan con
        relaci&oacute;n al incumplimiento de las normas sobre protecci&oacute;n de datos personales. El titular
        podr&aacute;
        en cualquier momento solicitar el retiro o el bloqueo de su nombre de los bancos de datos en los que se hallen
        sus
        datos. En toda comunicaci&oacute;n con fines de publicidad que se realice por correo, tel&eacute;fono, correo
        electr&oacute;nico, Internet u otro medio a distancia se deber&aacute; indicar, en forma expresa y destacada, la
        posibilidad del titular del dato de solicitar el retiro o bloqueo, total o parcial, de su nombre de la base de
        datos. A pedido del interesado, se deber&aacute; informar el nombre del responsable o usuario del banco de datos
        que
        provey&oacute; la informaci&oacute;n.</span></div>
    <p><span>IX.&nbsp;</span><span>ALTERACIONES O MODIFICACIONES:</span></p>
    <div>1.&nbsp;<span>Los
        prestadores se reservan el derecho, por razones t&eacute;cnicas, operativas y/o de fuerza mayor -incluso por
        causas
        epid&eacute;micas o pand&eacute;micas y medidas sanitarias y migratorias de los diferentes pa&iacute;ses en que
        se
        desarrolle la prestaci&oacute;n tur&iacute;stica-, de alterar total o parcialmente el ordenamiento diario y/o de
        servicios que componen el tour, antes o durante su ejecuci&oacute;n.&nbsp;</span></div>
    <div>2.&nbsp;<span>Salvo
        condici&oacute;n expresa en contrario, los hoteles estipulados podr&aacute;n ser cambiados por otro de igual o
        mayor
        categor&iacute;a dentro del mismo n&uacute;cleo urbano sin cargo alguno para el pasajero. Respecto de estas
        variaciones, en tanto sean efectuadas por razones de mejor confort, servicio y/o fuerza mayor el pasajero no
        tendr&aacute; derecho a compensaci&oacute;n alguna.&nbsp;</span></div>
    <div>3.&nbsp;<span>Rappi
        Travel. tendr&aacute; el derecho de anular cualquier tour.&nbsp;</span></div>
    <div>4.&nbsp;<span>4. Una vez
        comenza</span><span>do el viaje, la suspensi&oacute;n, modificaci&oacute;n o
        interrupci&oacute;n de los servicios por parte del pasajero por razones personales de cualquier &iacute;ndole,
        no
        dar&aacute; lugar a reclamo, reembolso o devoluci&oacute;n alguna. La interrupci&oacute;n de los servicios por
        causa
        imputable al pasajero acarrea costos. En todos los casos Rappi Travel se compromete a prestar asistencia
        t&eacute;cnica para que el pasajero pueda continuar su viaje en las mejores condiciones posibles conforme su
        alcance. El pasajero deber&aacute; asumir los costos por regreso anticipado, conforme las penalidades que cobren
        las
        l&iacute;neas a&eacute;reas.</span></div>
    <p><span>X.&nbsp;</span><span>CL&Aacute;USULA DE ARBITRAJE:</span><span>&nbsp;Toda
        cuesti&oacute;n que surja con motivo de la celebraci&oacute;n, cumplimiento, incumplimiento, pr&oacute;rroga o
        rescisi&oacute;n del presente, podr&aacute; ser sometida por las partes a la resoluci&oacute;n de la Unidad
        Defensa
        del Consumidor. Las partes de com&uacute;n acuerdo se someten a los Tribunales Arbitrales en materia de Turismos
        de
        la Rep&uacute;blica Oriental del Uruguay y/o de los Tribunales Arbitrales que funcionen en sus respectivas
        Asociaciones Regionales en tanto &eacute;stos fueren conformados. En caso de sometimiento a dicha
        jurisdicci&oacute;n, los contratantes se sujetan y dan por aceptadas todas las condiciones establecidas por la
        Reglamentaci&oacute;n del Tribunal Arbitral que les ser&aacute; entregada por &eacute;ste, oportunamente.</span>
    </p>
    <h4><span>XI.&nbsp;</span><span>NORMAS DE APLICACI&Oacute;N:</span></h4>
    <p><span>El presente,
        y en su caso la prestaci&oacute;n de los servicios, se regir&aacute; por estas condiciones generales por la Ley
        N&deg; 19.253, su decreto reglamentario y normas concordantes, as&iacute; como el C&oacute;digo Civil, el
        C&oacute;digo de Comercio y la Ley de Relaciones de Consumo - Defensa del Consumidor, conocida por las partes.
        Toda
        la documentaci&oacute;n que se genere a favor del pasajero y se entregue a Rappi Travel como consecuencia del
        viaje,
        conformar&aacute; el Contrato de Viaje, y es informaci&oacute;n confidencial, protegida por La Ley de
        Protecci&oacute;n de Datos Personales &ndash; Ley 18.331. En materia aerocomercial, rigen las estipulaciones de
        la&nbsp;</span><span>Direcci&oacute;n Nacional de Aviaci&oacute;n Civil e Infraestructura
        Aeron&aacute;utica (DINACIA</span></p>
    <h4><span>XII.&nbsp;</span><span>ACEPTACI&Oacute;N DE LOS T&Eacute;RMINOS DE CONTRATACI&Oacute;N:</span></h4>
    <div>El hecho de efectuar el pago del derecho de
        inscripci&oacute;n o la reserva del viaje, implica por parte tanto de Rappi Travel como del/de los pasajeros el
        pleno conocimiento y total conformidad con estas Condiciones Generales. Todos los servicios ofrecidos se
        encuentran
        sujetos a las modalidades, condiciones de cancelaci&oacute;n y/o de devoluci&oacute;n que establezcan los
        operadores
        tur&iacute;sticos, las compa&ntilde;&iacute;as a&eacute;reas, y fundamentalmente las disposiciones sanitarias
        dispuestas por las autoridades gubernamentales y/o migratorias de cada uno de los destinos, sean interiores o en
        viajes al exterior. Estas condiciones generales se informan presencialmente y se encuentran publicadas en el
        sitio
        web de&nbsp;<a
        href="https://legal.rappi.com.co/uruguay/terminos-y-condiciones-de-uso-de-plataforma-rappi/"><u><span>https://legal.rappi.com.co/uruguay/terminos-y-condiciones-de-uso-de-plataforma-rappi/</span></u></a><span>&nbsp;Es
        parte de los t&eacute;rminos de esta contrataci&oacute;n que la oferta est&aacute;
        sujeta a las correspondientes autorizaciones gubernamentales y/o sanitarias nacionales y/o extranjeras vigentes
        a la
        fecha del comienzo o finalizaci&oacute;n del viaje/estad&iacute;a. Las aerol&iacute;neas/navieras y dem&aacute;s
        prestadores vinculados a su viaje podr&aacute;n disponer protocolos que deber&aacute;n ser necesariamente
        observados
        por los pasajeros. El pasajero deber&aacute; estar atento a la informaci&oacute;n din&aacute;mica de las
        autoridades
        de los diferentes pa&iacute;ses destino de su viaje.</span></div>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <div>&nbsp;</div>
    <p>&nbsp;</p>
  </div>
</div>